/**
 * Data Room folder requests: the user-created folder as the server sends
 * it, and its creation, renaming, move and deletion.
 */

import { request } from './request.js';

/** One user-created folder. The six category roots are not folders. */
export interface DataRoomFolder {
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly category: string;
  readonly parentFolderId: string | null;
  readonly version: number;
  readonly createdAt: string;
  readonly updatedAt: string;
}

export function createDataRoomFolder(
  idempotencyKey: string,
  folder: { name: string; category?: string; parentFolderId?: string },
): Promise<{ folderId: string; slug: string; version: number }> {
  return request('POST', '/workspace/data-room/folders', {
    body: folder,
    idempotencyKey,
  });
}

export function renameDataRoomFolder(
  idempotencyKey: string,
  folderId: string,
  body: { expectedVersion: number; name: string },
): Promise<{ folderId: string; slug: string; version: number }> {
  return request(
    'POST',
    `/workspace/data-room/folders/${encodeURIComponent(folderId)}/rename`,
    { body, idempotencyKey },
  );
}

export function moveDataRoomFolder(
  idempotencyKey: string,
  folderId: string,
  body: { expectedVersion: number; category?: string; parentFolderId?: string },
): Promise<{ folderId: string; version: number; changed: boolean }> {
  return request(
    'POST',
    `/workspace/data-room/folders/${encodeURIComponent(folderId)}/move`,
    { body, idempotencyKey },
  );
}

export function deleteDataRoomFolder(
  idempotencyKey: string,
  folderId: string,
  body: { expectedVersion: number },
): Promise<{ folderId: string; deleted: boolean }> {
  return request(
    'POST',
    `/workspace/data-room/folders/${encodeURIComponent(folderId)}/delete`,
    { body, idempotencyKey },
  );
}
